import { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from 'redux/store';
import { fetchAnnouncementDetails } from 'redux/slices/announcements/announcementDetailSlice';
import { getDateAndTime, getFullName } from 'utils/helpers';
import AssistanceFooter from 'components/Common/AssistanceFooter';
import Button from 'components/Common/Button';
import CardWrapper from 'components/Common/CardWrapper';
import MuiLoader from 'components/Common/Loader';
import Routes from 'constants/routes';

function AnnouncementDetails() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id } = useParams();
    const { details, loading } = useSelector((state: RootState) => state.announcement.announcementDetails);
    const { title, data, message, createDate } = details || {};
    useEffect(() => {
        id && dispatch(fetchAnnouncementDetails(id));
    }, [id, dispatch]);

    const handleResendAnnouncement = () => {
        id && navigate(Routes.announcements.edit.replace(':id', id));
    };

    return (
        <CardWrapper>
            <MuiLoader loading={loading} absolute />
            <Stack justifyContent="center" alignItems="center">
                <Typography
                    sx={{
                        fontSize: { xs: 18, md: 26 },
                        mb: 2,
                        textAlign: 'left',
                        width: { xs: '75%', xl: '50%' },
                        color: '#220E40',
                        fontWeight: 400,
                    }}
                    variant="h1"
                >
                    {title}
                </Typography>
                <Typography
                    sx={{ mt: 2, mb: 4, textAlign: 'left', width: { xs: '75%', xl: '50%' }, fontSize: { xs: 12, md: 18 } }}
                    variant="body1"
                >
                    {message}
                </Typography>

                <Typography
                    sx={{ mt: 1, mb: 3, textAlign: 'left', width: { xs: '75%', xl: '50%' }, fontSize: { xs: 9, md: 14 } }}
                    variant="body1"
                >
                    Date sent: {createDate && getDateAndTime(createDate)}
                    <br />
                    <span>Created by: {typeof data === 'object' && getFullName(data)}</span>
                </Typography>

                <Button onClick={handleResendAnnouncement} sx={{ width: { xs: '100%', sm: '60%', xl: '50%' } }}>
                    Resend Announcement
                </Button>
            </Stack>
            <AssistanceFooter />
        </CardWrapper>
    );
}

export default AnnouncementDetails;
